// extracted by mini-css-extract-plugin
module.exports = {"input_number":"PriceInputField_input_number__7aDCJ"};